<template>
    <div class="app">
        <h2>Contact<br> support@waterguru.com<br> with any questions</h2>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'ContactUs',
    methods: {
        ...mapActions({
            spinnerStop: 'spinner/stop'
        })
    },
    mounted () {
        this.spinnerStop()
    }
}
</script>

<style scoped>
    .app {
        position: fixed;
        left: 0;
        top: 0;
        /*background-image: url('../assets/img/Wave-Background-Ownership-iPhoneX.jpg');*/
        background-position-y: top;
        background-size: 100%;
        width: 100%;
        height: 100%;
        margin: 0 auto;
    }

    h2 {
        position: absolute;
        top: 30%;
        text-align: center;
        width: 100%;
        font-family: Nunito, sans-serif;
        color: #23B8DC;
    }
</style>
